import {FileText} from 'lucide-react'

const footerTools = [
  // Conversion
  { cat: 'Conversion Tools', items: [
    'PDF to PNG', 'PDF to JPG', 'PDF to WebP', 'PDF to TIFF',
    'EPUB to PDF', 'MOBI to PDF', 'AZW to PDF', 'FB2 to PDF',
    'MD to PDF', 'HTML to PDF', 'XML to PDF', 'CSV to PDF',
    'Pages to PDF', 'KEY to PDF', 'Numbers to PDF', 'ODT to PDF',
    'DOCX to PDF', 'PPTX to PDF', 'XLSX to PDF', 'RTF to PDF',
  ]},
  { cat: 'PDF Editors & Viewers', items: [
    'PDF Editor', 'PDF Editor Mac', 'PDF Annotator', 'PDF Page Reorder',
    'PDF Splitter', 'PDF Merger', 'PDF Compressor', 'PDF Viewer',
    'DOCX Viewer', 'EPUB Viewer', 'ODT Viewer', 'XLS Viewer',
    'PDF Rotate', 'PDF Crop', 'PDF Watermark', 'PDF to Text',
  ]},
  { cat: 'Dev / Tech Utilities', items: [
    'IPYNB to PDF', 'MuPDF Web', 'Make PDF Searchable',
    'PDF to Scanned PDF', 'CDR to PDF', 'SVG to PDF',
    'Base64 to PDF', 'PDF to Base64', 'JSON to PDF', 'YAML to PDF',
    'PDF Metadata Editor', 'PDF Repair',
  ]},
  { cat: 'eBook Tools', items: [
    'EPUB to MOBI', 'MOBI to EPUB', 'EPUB Converter',
    'AZW3 to EPUB', 'LIT to PDF', 'CBZ to PDF', 'CBR to PDF',
  ]},
  { cat: 'OCR & Accessibility', items: [
    'PDF OCR', 'Scanned PDF to Text', 'PDF to Word',
    'PDF Accessibility Check', 'Tagged PDF Creator',
  ]},
]

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-white border-t border-gray-100 pt-16 pb-8 px-4" role="contentinfo">
      <div className="max-w-7xl mx-auto">
        {/* Brand */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8 mb-14">
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8 rounded-lg bg-indigo-600 flex items-center justify-center">
                <FileText size={16} className="text-white" />
              </div>
              <span
                className="font-semibold text-gray-900 text-lg tracking-tight"
                style={{ fontFamily: 'Space Grotesk, sans-serif' }}
              >
                Pdf<span className="text-indigo-600">Tide</span>
              </span>
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              The high-speed, browser-first PDF utility hub. All processing happens
              in your browser — no files sent to servers, ever.
            </p>
          </div>

          <div className="flex gap-6 text-sm text-gray-500 flex-wrap">
            {['Privacy Policy', 'Terms of Service', 'About', 'Blog', 'API Docs'].map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase().replace(/ /g, '-')}`}
                className="hover:text-indigo-600 transition-colors"
              >
                {link}
              </a>
            ))}
          </div>
        </div>

        {/* Tool Link Grid — internal PageRank distribution */}
        <nav aria-label="All PDF tools">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8">
            {footerTools.map((section) => (
              <div key={section.cat}>
                <h3 className="text-xs font-bold text-gray-900 uppercase tracking-widest mb-4">
                  {section.cat}
                </h3>
                <ul className="space-y-2.5" role="list">
                  {section.items.map((tool) => (
                    <li key={tool}>
                      <a
                        href={`#${tool.toLowerCase().replace(/ /g, '-')}`}
                        className="text-sm text-gray-500 hover:text-indigo-600 transition-colors leading-snug block"
                      >
                        {tool}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </nav>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-400">
          <p>© {currentYear} PdfTide. All rights reserved. Browser-first processing — zero file uploads.</p>
          <div className="flex items-center gap-1">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" aria-hidden="true" />
            <span>All systems operational</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
